import { useState } from "react";
import { formatINR } from "../lib/api";

export default function EmiCalculator({ price }) {
  const [down, setDown] = useState(20);
  const [rate, setRate] = useState(9.5);
  const [years, setYears] = useState(5);
  const principal = price * (1 - down / 100);
  const r = rate / 1200;
  const n = years * 12;
  const emi = r ? (principal * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1) : principal / n;
  const Row = ({ label, v, set, min, max, step, suffix, id }) => (
    <div>
      <div className="flex justify-between text-xs mb-2"><span className="text-gray-400">{label}</span><span className="text-[#E5C158]">{v}{suffix}</span></div>
      <input type="range" min={min} max={max} step={step} value={v} onChange={(e) => set(Number(e.target.value))} className="w-full accent-[#D4AF37]" data-testid={id} />
    </div>
  );
  return (
    <div className="lux-card p-6 space-y-5" data-testid="emi-calculator">
      <p className="eyebrow">EMI Calculator</p>
      <p className="font-display text-4xl gold-text" data-testid="emi-value">₹{Math.round(emi).toLocaleString("en-IN")}<span className="text-sm text-gray-500 font-sans"> /month</span></p>
      <Row label="Down payment" v={down} set={setDown} min={0} max={80} step={5} suffix="%" id="emi-down" />
      <Row label="Interest rate" v={rate} set={setRate} min={7} max={18} step={0.5} suffix="%" id="emi-rate" />
      <Row label="Tenure" v={years} set={setYears} min={1} max={7} step={1} suffix=" yrs" id="emi-years" />
      <p className="text-xs text-gray-500">Loan amount {formatINR(Math.round(principal))}</p>
    </div>
  );
}
